import { render, staticRenderFns } from "./RirekishoShortPreview.vue?vue&type=template&id=016ae5af"
import script from "./RirekishoShortPreview.vue?vue&type=script&lang=js"
export * from "./RirekishoShortPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports